import { combineReducers } from 'redux';

import { IApplicationState, TReduxActions } from '../types/redux';
import { experimentsReducer } from './experiments';

export const reducers = combineReducers<IApplicationState, TReduxActions>({
  experiments: experimentsReducer,
});
